module.exports = __webpack_public_path__ + "static/media/1 22 love.1b375688.mp3";